import { PhoneInput, type PhoneNumberResult } from '@vp/contact-channels'
import { Box } from '@vp/swan'
import type { Control } from 'react-hook-form'
import { useController } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { ContactDetailsFields } from '../../../hooks/use-contact-details'
import styles, { stylesheet } from '../styles.scss'
import { useStyles } from '@vp/ubik-context'

interface ContactPhoneFieldProps {
  control: Control<ContactDetailsFields>
}

export const ContactPhoneField = ({ control }: ContactPhoneFieldProps) => {
  const { t } = useTranslation()
  useStyles(stylesheet)
  const { field: countryField } = useController({
    name: 'country',
    control,
    rules: { required: true },
  })
  const { field: phoneField } = useController({
    name: 'phone',
    control,
    rules: { required: true, validate: (v: PhoneNumberResult) => !!v.isValid },
  })

  return (
    <Box data-testid="phone-field">
      <PhoneInput
        defaultCountry={countryField.value?.code}
        defaultPhoneNumber={phoneField.value?.phoneNumber}
        containerOverrides={{ flexDirection: { xs: 'column', sm: 'row' }, gap: { xs: 0, sm: 6 } }}
        countryVariant="listbox"
        onChange={(country, phone) => {
          countryField.onChange(country)
          phoneField.onChange(phone)
        }}
        countryDropdownOverrides={{
          name: 'country',
          label: t('contact_us.page.steps.details.fields.country_label'),
          formFieldProps: { style: { flex: 1, minWidth: 0, overflow: 'hidden' } },
          inputGroupProps: { mb: undefined },
          listboxButtonProps: { className: styles.countryListBoxButton },
        }}
        phoneInputOverrides={{
          name: 'phone',
          label: t('contact_us.page.steps.details.fields.phone_label'),
          inputGroupProps: { mb: undefined },
        }}
      />
    </Box>
  )
}
